import * as React from 'react';
import Tour from 'v2/components/Shared/Tour';

import type { Step } from 'react-joyride';

const steps: Step[] = [
  {
    target: '#webhook-v2-screen',
    content: 'Bem-vindo(a) ao novo Webhook, nessa versão trouxemos algumas novidades. Confira!',
  },
  {
    target: '#webhook-v2-history-action',
    content: 'O histórico mudou! Clicando aqui o histórico de eventos será expandido e você terá a acesso a todos os eventos da URL.',
  },
  {
    target: '#webhook-v2-button-new',
    content:
      'Para não ter erros no cadastro de um novo Webhook, implementamos uma verificação onde validamos para você se aquela URL se encontrá apta a receber seus eventos.',
  },
  {
    target: '#webhook-v2-button-help',
    content:
      'Aqui você encontra um vídeo explicando todas as mudanças, esclarecimento e novidades como novo status "Com erro", Inteligência de ativação e desativação de URL, Backup de eventos, fila de envio sem lentidão e tudo sobre o novo Webhook.',
  },
];

const WebhookTour = () => {
  return <Tour name='webhook-v2' steps={steps} />;
};

export default WebhookTour;
